export const QA = {
    default: {
        audio: "Use the shortcut to capture the interviewer's audio",
        summary: "Is interview summary available to download?",
        transcripts: "Yes, it is available after you click the bottom right corner of the copilot page. You can access and download transcripts of your interviews directly."
    },
    assistant: {
        audio: "Use the shortcut to capture the speaker's audio",
        summary: "Is session summary available to download?",
        transcripts: "Yes, it is available after you click the bottom right corner of the assistant page. You can access and download transcripts of your sessions directly."
    }
};

export const DEMO = {
    default: { interviewer: "Interviewer", copilot: "Copilot" },
    assistant: { interviewer: "Speaker", copilot: "Assistant" }
};

export const DISCOUNT = {
    default: {
        subtitle: "Last chance before interviews go on-site! Join 10,000+ successful candidates",
        footer: "Download Interview Copilot now and get ready to ace your interviews."
    },
    assistant: {
        subtitle: "Last chance to upgrade your workflow! Join 10,000+ successful users",
        footer: "Download AI Assistant now and get ready to master your calls."
    }
};

export const POPUP = {
    default: { description: "Unlock our most powerful interview copilot and exclusive tips" },
    assistant: { description: "Unlock our most powerful AI assistant and exclusive tips" }
};

export const SEO = {
    default: {
        title: "ConvoCue AI: Interview Copilot",
        description: "ConvoCue AI answers your interview questions in real-time. Triple your chance to crack a job interview with our AI-powered interview preparation tool."
    },
    assistant: {
        title: "ConvoCue AI: Real-time AI Assistant",
        description: "ConvoCue AI provides real-time assistance during your calls. Enhance your performance with our AI-powered call assistant."
    }
};
